import { Globe } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";

export const LanguageToggle = ({ variant = "navbar" }) => {
  const { lang, toggleLang } = useI18n();
  const isMs = lang === "ms";

  const baseClass =
    variant === "mobile"
      ? "inline-flex w-full items-center justify-between gap-2 px-3 py-2.5 rounded-lg text-sm font-semibold text-[#0A2342] hover:bg-slate-50 transition-colors"
      : "inline-flex items-center gap-2 rounded-full bg-white/70 backdrop-blur border border-slate-200 px-3 py-1.5 text-xs font-bold text-[#0A2342] hover:border-[#2563EB]/40 hover:text-[#2563EB] transition-all";

  return (
    <button
      type="button"
      onClick={toggleLang}
      aria-label={`Switch language to ${isMs ? "English" : "Bahasa Malaysia"}`}
      data-testid={`lang-toggle${variant === "mobile" ? "-mobile" : ""}`}
      className={baseClass}
    >
      <Globe className="w-3.5 h-3.5" />
      <span className="flex items-center gap-1">
        <span
          className={`tracking-wider transition-colors ${
            !isMs ? "text-[#2563EB]" : "text-slate-400"
          }`}
          data-testid="lang-en"
        >
          EN
        </span>
        <span className="text-slate-300">/</span>
        <span
          className={`tracking-wider transition-colors ${
            isMs ? "text-[#2563EB]" : "text-slate-400"
          }`}
          data-testid="lang-ms"
        >
          BM
        </span>
      </span>
    </button>
  );
};

export default LanguageToggle;
